import { createTheme } from '@material-ui/core/styles';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const color = cookies.get('System-Color');

const Light = {
  palette: {
    primary: {
      main: '#159B78',
    },
    secondary: {
      main: '#159B78',
      background: '#f2f2f2',
    },
    text: {
      primary: '#666666',
      secundary: '#f2f2f2'
    },
    type: 'light',
  },
  overrides: {
    MuiLink: {
      root: {
        color: '#666666'
      }
    },
    MuiFilledInput: {
      root: {
        color: '#159B78',
      },
    },
  }
};

const Dark = {
  palette: {
    primary: {
      main: '#fff',
      light: 'rgba(40,40,40,1)',
    },
    secondary: {
      main: 'rgba(255,255,255,1)',
      light: '#f2f2f2',
      background:'#666666',
    },
    text: {
      primary:'#f2f2f2',
      secundary: 'rgba(40,40,40,1)',
    },
    type: 'dark',
  },
  overrides: {
    MuiLink: {
      root: {
        color: '#fff'
      }
    },
    MuiFilledInput: {
      root: {
        color: '#fff',
      },
    },
  }
};

export default createTheme({
    overrides: {
      MUIDataTable: {
        responsiveScroll: {
          maxHeight: 'none',
          height: '400px'
        },
        responsiveScrollFullHeight: {
          maxHeight: 'calc(100vh - 240px) !important',
          overflowX:'auto'
        },
        responsiveStacked: {
          marginTop:'54px',
        }
      },
      MUIDataTableBody:{
        emptyTitle: {
          textAlign: 'left'
        }
      },
      MUIDataTableHeadCell: {
        root:{
          whiteSpace: 'nowrap'
        }
      },
      MUIDataTableBodyCell: {
        root:{
          whiteSpace: 'nowrap'
        }
      },
      MuiExpansionPanelDetails: {
        root: {
          paddingBottom: 8,
        }
      },
      MuiTableCell: {
        sizeSmall: {
          fontSize:'12px',
        },
      },
      MuiListItemText: {
        dense: {
          marginTop: '0',
          marginBottom: '0',
        }
      },
      MUIDataTableToolbar: {
        titleText: {
          textTransform: 'capitalize'
        },
      },
      MuiListItemIcon: {
        root: {
          minWidth: '32px',
        }
      },
      MuiFilledInput: {
        root: {
          backgroundColor: 'rgba(0,0,0,0.05)',
        },
      },
      ...((color==null||color==='light')?Light.overrides:Dark.overrides)
    },
    typography: {
      fontFamily: [
        'Margem',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
      ].join(','),
    },
    palette: (color==null||color==='light')?Light.palette:Dark.palette,
});